import { Maybe } from "../../../core/models";

export class FilterService {
    maybeFilter: Maybe<string | null>;

    constructor(filterValue: string | null = null) {
        this.maybeFilter = Maybe.justIf(this.isValid(filterValue), filterValue);
    }

    applyFilter<T>(list: readonly T[], getSearchKey: (value: T) => string): readonly T[] {
        return this.maybeFilter.ifElse(
            (value) =>
                list.filter((listItem) =>
                    getSearchKey(listItem)
                        .toLowerCase()
                        .includes((value ?? "").toLowerCase()),
                ),
            () => list,
        );
    }

    get isValueEmpty() {
        return this.maybeFilter.value === "";
    }

    private isValid(filterValue: string | null) {
        return filterValue != null;
    }
}
